import { StateCreator } from 'zustand'
import { SharedSlice } from 'src/components/slice'

interface ManageState {}

export interface ManageSlice extends ManageState {
  /**
   * Resets PayClassifications Slice state
   */
  resetManageSlice: () => void
}

const initialState: ManageState = {}

const createManageSlice: StateCreator<
  ManageSlice & SharedSlice,
  [],
  [],
  ManageSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetManageSlice: () => set(initialState),
})

export default createManageSlice
